/*
 * @Author: lsqbeyond lsqbeyond@yeah.net
 * @Date: 2025-10-06 13:18:49
 * @LastEditors: lsqbeyond lsqbeyond@yeah.net
 * @LastEditTime: 2025-10-06 13:19:21
 * @FilePath: \tracenew\src\i18n\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 导入语言文件
import zh from './locales/zh'
import en from './locales/en'
import de from './locales/de'

const messages = {
  zh,
  en,
  de
}

const i18n = new VueI18n({
  locale: 'zh', // 默认语言
  fallbackLocale: 'zh', // 回退语言
  messages
})

export default i18n